import React from 'react';
import Timesheets from './Timesheets';

const MyTimeOff = () => {
  return <Timesheets initialTab="pto" showAdminTabs={false} />;
};

export default MyTimeOff;
